import { Modal } from 'components/Modal';
import styles from 'common/Settings/Settings.scss';

export const Settings = ({ isOpen, setIsOpen }) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} className={styles.modal}>
      <article className={styles.window}>Налаштування</article>
    </Modal>
  );
};
